import React, { useState, useEffect } from "react";
import { Row, Col, Tag, Tooltip } from "antd";
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  BarChartOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { useGetConsultantAlertsSummaryQuery } from "../../../Redux/service/Consultant/ConsultantDashboard";
import Loader from "../../Helpers/Loader/Loader";
import trans from "../../../utils";

const colorScheme = {
  critical: "red",
  high: "volcano",
  medium: "orange",
  low: "green",
  neutral: "blue",
  success: "green",
  danger: "red",
};

const getSeverityColor = (severity) => {
  switch (severity) {
    case "critical":
      return "error";
    case "high":
      return "warning";
    case "medium":
      return "processing";
    case "low":
      return "success";
    default:
      return "default";
  }
};

export default function ConsultantAlertsSummary({ refreshKey }) {
  const {
    data: alerts,
    isLoading,
    refetch,
  } = useGetConsultantAlertsSummaryQuery(
    { refreshKey },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    refetch();
  }, [refreshKey]);

  if (isLoading) {
    return <Loader />;
  }

  const alertTypes = [
    {
      key: "pendingRequests",
      title: trans("Pending Requests"),
      icon: <FileTextOutlined />,
      color: colorScheme.high,
      severity: "High",
      tooltip: trans("Requests pending review."),
      dataKey: "pending",
    },
    {
      key: "approvedToday",
      title: trans("Approved Today"),
      icon: <CheckCircleOutlined />,
      color: colorScheme.success,
      severity: "Low",
      tooltip: trans("Requests approved today."),
      dataKey: "approved_today",
    },
    {
      key: "rejectedToday",
      title: trans("Rejected Today"),
      icon: <CloseCircleOutlined />,
      color: colorScheme.danger,
      severity: "Medium",
      tooltip: trans("Requests rejected today."),
      dataKey: "rejected_today",
    },
    // {
    //   key: "avgTurnaroundHours",
    //   title: trans("Avg Turnaround Hours"),
    //   icon: <ClockCircleOutlined />,
    //   color: colorScheme.medium,
    //   severity: "Medium",
    //   tooltip: trans("Average turnaround time in hours."),
    // },
    {
      key: "totalReviewed",
      title: trans("Total Reviewed"),
      icon: <BarChartOutlined />,
      color: colorScheme.neutral,
      severity: "Low",
      tooltip: trans("Total requests reviewed."),
      dataKey: "total_reviewed",
    },
  ];

  return (
    <Row gutter={[8, 8]}>
      {alertTypes.map((alert) => {
        const alertData = alerts?.data?.[alert.dataKey];
        return (
          <Col xs={24} sm={12} md={6} key={alert.key}>
            <Tooltip title={trans(alert.tooltip)}>
              <div
                className="bg-white-rounded p-12 my-3 cursor"
                style={{
                  borderRadius: "12px",
                  padding: "10px 14px",
                  background:
                    "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  height: "100px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    marginTop: 8,
                    justifyContent: "space-between",
                  }}
                >
                  {/* Title */}
                  <div>
                    <p
                      className="fs-12 fw-600 neutral-500"
                      style={{ color: "#42526E" }}
                    >
                      {alert.title}
                    </p>
                  </div>
                  <div>
                    <Tag
                      color={getSeverityColor(alert.severity.toLowerCase())}
                      style={{ fontWeight: 600, fontSize: 12 }}
                    >
                      {trans(alert.severity)}
                    </Tag>
                  </div>
                </div>

                {/* Count + change */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 8,
                    justifyContent: "start",
                  }}
                >
                  <span
                    style={{
                      fontSize: 20,
                      fontWeight: 700,
                      marginRight: 8,
                      color: "#111827",
                    }}
                  >
                    {alertData || 0}
                  </span>
                  {/* {change !== 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 4,
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={
                          change > 0
                            ? `${process.env.PUBLIC_URL}/assets/incbad.svg`
                            : `${process.env.PUBLIC_URL}/assets/decgood.svg`
                        }
                        alt=""
                      />
                      <span
                        style={{
                          fontSize: 10,
                          fontWeight: 500,
                          color:
                            change > 0
                              ? colorScheme.danger
                              : colorScheme.success,
                        }}
                      >
                        {change > 0 ? `+${change}%` : `${change}%`}
                      </span>
                      <p
                        style={{
                          fontSize: 10,
                          fontWeight: 400,
                          color:
                            change > 0
                              ? colorScheme.danger
                              : colorScheme.success,
                          marginBottom: 0,
                        }}
                      >
                        {trans("vs yesterday")}
                      </p>
                    </div>
                  )} */}
                </div>
              </div>
            </Tooltip>
          </Col>
        );
      })}
    </Row>
  );
}
